var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElegantTable1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V4.06643C10.8399 4.1749 10.4701 4.41237 10.1995 4.75061L8.38635 7.01707C8.13625 7.32968 8 7.71811 8 8.11846C8 8.60532 8.39468 9 8.88154 9H10.2676C10.6134 9.5978 11.2597 10 12 10C12.7403 10 13.3866 9.5978 13.7324 9H15.1185C15.6053 9 16 8.60532 16 8.11846C16 7.71811 15.8637 7.32968 15.6137 7.01707L13.8005 4.75061C13.5299 4.41237 13.1601 4.1749 12.75 4.06643V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14C2 13.4477 2.44772 13 3 13H21C21.5523 13 22 13.4477 22 14V15C22 15.5523 21.5523 16 21 16H20.75V22C20.75 22.4142 20.4142 22.75 20 22.75C19.5858 22.75 19.25 22.4142 19.25 22V16H17.25V19.5C17.25 19.9142 16.9142 20.25 16.5 20.25C16.0858 20.25 15.75 19.9142 15.75 19.5V16H8.25V19.5C8.25 19.9142 7.91421 20.25 7.5 20.25C7.08579 20.25 6.75 19.9142 6.75 19.5V16H4.75V22C4.75 22.4142 4.41421 22.75 4 22.75C3.58579 22.75 3.25 22.4142 3.25 22V16H3C2.44772 16 2 15.5523 2 15V14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElegantTable1);
export default __webpack_public_path__ + "static/media/elegant-table-1.13a02d79d64c1c6c5983205cecac0456.svg";
export { ForwardRef as ReactComponent };